import { createSlice } from '@reduxjs/toolkit'
import {
  duplicateGoodThunk,
  fetchGoodById,
  fetchGoodParcelByID,
  fetchGoodStatusHistory,
  fetchGoodsByStatus,
  // fetchPhotoDefectData,
  // fetchPhotoReportData,
  fetchCargoDetails,
  createWaifRegister,
  fetchDeliveryTransaction,
  fetchChangeWeight,
  fetchGoodCellHistory,
  updateGoodThunk,
  removeGoodFromParcel,
  // fetchCargoPhotoData,
  fetchGoodsByParcelId,
  fetchGoodsOldThenFiveDays,
  cancelGoods,
  putYiliGoods,
  fetchGoodsByQuery,
  getReadyGoods,
  fetchGoods,
  fetchProductDescription,
  fetchAwaitingInStoreGoods,
  fetchAwaitingInStoreGoodById,
  fetchAwaitingInStoreById,
  disposeAwaitingInStoreGood,
  fetchAwaitingInStoreExtendedGoods,
  // fetchGoodsByDate
} from './thunk'

const initialState = {
  goods: [],
  goodsTotalElements: 0,
  goodsTotalPages: 0,
  goodsTotalElementsByQuery: 0,
  isFetchGoodsLoading: false,
  fetchGoodsError: undefined,

  isDuplicateGoodsLoading: false,
  duplicateGoodsError: undefined,

  photoReportData: [],
  photoDefectData: [],
  acceptCargoAdditionalServices: [],
  hasPhotoReportService: false,
  // photoDefectUrl: '',
  photoReportDataLoading: false,
  photoDefectDataLoading: false,
  photoDefectDataError: false,

  isUpdateGoodLoading: false,
  updateGoodError: '',

  productDescriptionLoading: false,
  productDescriptionError: null,

  goodsForRegistry: [],
  goodsFilteredDataForRegistry: [],
  goodsForRegistryLoading: false,
  goodsForRegistryError: undefined,

  cargoDetails: {},
  cargoDataLoading: false,
  cargoDataError: undefined,

  waifDetails: {},
  waifLoading: false,
  waifError: undefined,
  // photoDefectDataLoading: false
  fetchedGood: {},
  isFetchGoodLoading: false,
  fetchGoodError: undefined,

  goodParcelData: {},
  goodParcelLoading: false,
  goodParcelError: undefined,

  yiliGoodsLoading: false,

  goodsParcel: {},

  readyGoods: {},
  readyGoodsLoading: false,
  readyGoodsError: undefined,

  goodStatusHistoryData: [],
  isFetchGoodStatusHistoryLoading: false,
  fetchGoodStatusHistoryError: undefined,

  transactionDetails: {},
  transactionLoading: false,
  transactionError: undefined,

  changedGoodData: {},
  changedGoodError: undefined,
  changedGoodLoading: false,

  transactionError: undefined,
  shouldTakePicture: false,
  webCameraData: { file: null, goodId: null },

  goodCellHistoryData: [],
  isFetchGoodCellHistoryLoading: false,
  fetchGoodCellHistoryDataError: undefined,

  goodsList: [],
  goodsListLoading: false,
  goodsListLoadingError: null,

  cargoPhotoData: [],
  cargoPhotoLoading: false,
  cargoPhotoError: null,

  fetchGoodsByParcelIdLoading: true,

  goodsOldThenFiveDays: [],
  goodsOldThenFiveDaysLoading: false,
  goodsOldThenFiveDaysError: null,

  cancelGoodsError: null,
  cancelGoodsLoading: false,

  awaitingInStoreGoods: [],
  awaitingInStoreGoodsTotalElements: 0,
  awaitingInStoreGoodsTotalPages: 0,
  awaitingInStoreGoodsLoading: false,
  awaitingInStoreGoodsError: undefined,

  awaitingInStoreGood: {},
  awaitingInStoreGoodLoading: false,
  awaitingInStoreGoodError: undefined,

  disposeAwaitingInStoreLoading: false,
  disposeAwaitingInStoreError: undefined,

  selectedItem: {},

  removeGoodFromParcelLoading: false,
  removeGoodFromParcelError: undefined,
  removedGoodFromParcel: undefined,
}

const slice = createSlice({
  name: 'goods',
  initialState,
  reducers: {
    // setGoods(state, action) {
    //   state.goods = action.payload;
    // },
    deletePhotoReportPicture(state, action) {
      state.photoReportData = action.payload
    },
    deletePhotoDefectPicture(state, action) {
      state.photoDefectData = action.payload
    },
    setCargoPhotoData(state, { payload }) {
      state.cargoPhotoData = payload
    },
    clearPhotoDefectData(state) {
      state.photoDefectData = []
    },
    setSelectedGood(state, { payload }) {
      state.selectedItem = payload
    },
    setGoods(state, { payload }) {
      state.goods = payload
    },
    setFetchedGood(state, { payload }) {
      state.fetchedGood = payload
    },
    // setPhotoReportUrl(state, action) {
    //   state.photoReportUrl = action.payload;
    // },
    // setPhotoDefectUrl(state, action) {
    //   state.photoDefectUrl = action.payload;
    // },
    clearPhotoReportData(state) {
      state.photoReportData = []
      // ALSO CLEAR OTHER DATA, MIGHT AS WELL ADD SEPARATE REDUCER
      state.hasPhotoReportCargo = false
      state.acceptCargoAdditionalServices = []
    },
    getAdditionalServicesOfAcceptCargo(state, action) {
      state.acceptCargoAdditionalServices = action.payload
    },
    clearChangedGoodData(state) {
      state.changedGoodData = {}
    },

    setShouldTakePicture(state, { payload }) {
      state.shouldTakePicture = payload
    },

    setWebCameraData(state, { payload }) {
      state.webCameraData = { ...state.webCameraData, ...payload }
    },
    filterGoodsById(state, { payload }) {
      state.goodsOldThenFiveDays = state.goodsOldThenFiveDays.filter(
        (val) => val.id !== payload?.goodsId
      )
    },
    clearWebCameraData(state) {
      state.webCameraData = {}
    },
    clearWaifDetailsData(state) {
      state.waifDetails = {}
    },
    filterDataByDate(state, { payload }) {
      state.goodsFilteredDataForRegistry = state.goodsForRegistry?.filter(
        (item) => {
          const makeArray = Object.entries(payload)
          return makeArray.find(([key, value]) => {
            const data = String(item[key]).toLowerCase()
            const searchingData = value.toLowerCase()
            return data.includes(searchingData)
          })
        }
      )
    },
    getOneParcelsGoods(state, { payload }) {
      state.goodsParcel = state.goodsForRegistry.find((val) => {
        return Number(payload.parcelId) === val.id
      })
    },
    filterByParcelId(state, { payload }) {
      state.goodsForRegistry = state.goodsForRegistry.filter((val) => {
        return Number(payload.parcelId) !== val.id
      })
    },
    clearGoodsForRegistry(state) {
      state.goodsForRegistry = []
    },
    cleanGoods(state) {
      state.goods = []
    },
    cleanAwaitingInStoreGoods(state) {
      state.awaitingInStoreGoods = []
      state.awaitingInStoreGoodsTotalElements = 0
      state.awaitingInStoreGoodsTotalPages = 0
      state.awaitingInStoreGoodsError = undefined
    },
    clearAwaitingInStoreGood(state) {
      state.awaitingInStoreGood = {}
      state.awaitingInStoreGoodError = undefined
    },
    clearCargoDetails(state) {
      state.cargoDetails = {}
      state.cargoDataError = undefined
    },
  },
  extraReducers: {
    [removeGoodFromParcel.pending]: (state) => {
      state.removeGoodFromParcelLoading = true
      state.removeGoodFromParcelError = undefined
    },
    [removeGoodFromParcel.fulfilled]: (state, { payload }) => {
      state.removeGoodFromParcelLoading = false
      state.removedGoodFromParcel = payload?.data

      const goodsId = payload?.goodsId
      if (!goodsId) return

      // Optimistically reflect removal in cached lists (if present)
      if (Array.isArray(state.goods)) {
        state.goods = state.goods.map((g) =>
          g?.id === goodsId ? { ...g, parcelId: null } : g
        )
      }
      if (Array.isArray(state.goodsOldThenFiveDays)) {
        state.goodsOldThenFiveDays = state.goodsOldThenFiveDays.map((g) =>
          g?.id === goodsId ? { ...g, parcelId: null } : g
        )
      }
      if (state.goodsParcel?.goods && Array.isArray(state.goodsParcel.goods)) {
        state.goodsParcel.goods = state.goodsParcel.goods.filter(
          (g) => g?.id !== goodsId
        )
      }
    },
    [removeGoodFromParcel.rejected]: (state, { payload }) => {
      state.removeGoodFromParcelLoading = false
      state.removeGoodFromParcelError = payload
    },
    [fetchGoodsByParcelId.pending]: (state) => {
      state.fetchGoodsByParcelIdLoading = true
    },
    [fetchGoodsByParcelId.fulfilled]: (state, { payload }) => {
      state.fetchGoodsByParcelIdLoading = false
      state.goodsParcel = {
        id: payload[0]?.parcelId,
        clientId: payload[0]?.client.id,
        goods: payload,
      }
    },
    [fetchGoodsByParcelId.rejected]: (state) => {
      state.fetchGoodsByParcelIdLoading = false
    },
    // [fetchPhotoReportData.pending]: (state) => {
    //   state.photoReportDataLoading = true
    // },
    // [fetchPhotoReportData.fulfilled]: (state, action) => {
    //   state.photoReportDataLoading = false
    //   state.photoReportData = action.payload || []
    // },
    // [fetchPhotoReportData.rejected]: (state) => {
    //   state.photoReportDataLoading = false
    // },
    [putYiliGoods.pending]: (state) => {
      state.yiliGoodsLoading = true
    },
    [putYiliGoods.fulfilled]: (state) => {
      state.yiliGoodsLoading = false
    },
    [putYiliGoods.rejected]: (state) => {
      state.yiliGoodsLoading = false
    },
    [getReadyGoods.pending]: (state) => {
      state.readyGoodsLoading = true
    },
    [getReadyGoods.fulfilled]: (state, { payload }) => {
      state.readyGoodsLoading = false
      state.readyGoods = payload || {}
    },
    [getReadyGoods.rejected]: (state, { payload }) => {
      state.readyGoodsLoading = false
      state.readyGoodsError =
        payload.message || payload.error || 'Error fetching ready goods'
    },
    // [fetchPhotoDefectData.pending]: (state) => {
    //   state.photoDefectDataLoading = true
    // },
    // [fetchPhotoDefectData.fulfilled]: (state, { payload }) => {
    //   state.photoDefectDataLoading = false
    //   state.photoDefectData = payload || []
    // },
    // [fetchPhotoDefectData.rejected]: (state, { payload }) => {
    //   state.photoDefectDataLoading = false
    //   state.photoDefectDataError = payload?.error
    // },

    // [fetchGoodsByDate.pending]: (state) => {
    //   state.goodsForRegistryLoading = true;
    // },
    // [fetchGoodsByDate.fulfilled]: (state, { payload }) => {
    //   state.goodsForRegistryLoading = false;
    //   const parcelsIds = [];
    //   const parcels = [];
    //   payload?.data?.map((goods) => {
    //     if (!goods.parcelId) return;
    //     if (parcelsIds.includes(goods.parcelId)) {
    //       parcels.map((parcel) => {
    //         if (parcel.id === goods.parcelId) {
    //           parcel.goods?.push(goods);
    //           return parcel;
    //         }
    //       });
    //     } else {
    //       parcelsIds.push(goods.parcelId);
    //       parcels.push({
    //         id: goods.parcelId,
    //         clientId: goods.client.id,
    //         goods: [goods]
    //       });
    //     }
    //   });
    //   parcels.sort((a, b) => b.id - a.id);
    //   state.goodsForRegistry = parcels || [];
    // },
    // [fetchGoodsByDate.rejected]: (state, { payload }) => {
    //   state.goodsForRegistryLoading = false;
    //   state.goodsForRegistryError = payload?.error;
    // },

    [duplicateGoodThunk.pending]: (state) => {
      state.isDuplicateGoodsLoading = true
    },
    [duplicateGoodThunk.fulfilled]: (state, action) => {
      state.isDuplicateGoodsLoading = false
      state.goods = [...state.goods, action.payload]
    },
    [duplicateGoodThunk.rejected]: (state, action) => {
      state.isDuplicateGoodsLoading = false
      state.duplicateGoodsError = action.payload.error
        ? action.payload.error
        : action.payload
    },
    [fetchGoodsOldThenFiveDays.pending]: (state) => {
      state.goodsOldThenFiveDaysLoading = true
    },
    [fetchGoodsOldThenFiveDays.fulfilled]: (state, { payload }) => {
      state.goodsOldThenFiveDaysLoading = false
      state.goodsOldThenFiveDays = payload.data
    },
    [fetchGoodsOldThenFiveDays.rejected]: (state, { error }) => {
      state.goodsOldThenFiveDaysLoading = false
      state.goodsOldThenFiveDaysError = error
    },
    [fetchGoodsByStatus.pending]: (state) => {
      state.isFetchGoodsLoading = true
    },
    [fetchGoodsByStatus.fulfilled]: (state, { payload }) => {
      state.isFetchGoodsLoading = false
      state.goods = payload.data || []
      state.goodsTotalElements = payload.totalElements
      state.goodsTotalPages = payload.totalPages
    },
    [fetchGoodsByStatus.rejected]: (state, { payload }) => {
      state.isFetchGoodsLoading = false
      state.fetchGoodsError = payload.error
    },
    [fetchGoodsByQuery.pending]: (state) => {
      state.isFetchGoodsLoading = true
    },
    [fetchGoodsByQuery.fulfilled]: (state, { payload }) => {
      state.isFetchGoodsLoading = false
      state.goods = payload.data || []
      state.goodsTotalElements = payload.totalElements
      state.goodsTotalPages = payload.totalPages
    },
    [fetchGoodsByQuery.rejected]: (state, { payload }) => {
      state.isFetchGoodsLoading = false
      state.fetchGoodsError = payload.error
    },
    [fetchAwaitingInStoreGoods.pending]: (state) => {
      state.awaitingInStoreGoodsLoading = true
      state.awaitingInStoreGoodsError = undefined
    },
    [fetchAwaitingInStoreGoods.fulfilled]: (state, { payload }) => {
      state.awaitingInStoreGoodsLoading = false
      const normalizedData = payload?.data || payload?.content || payload || []
      state.awaitingInStoreGoods = Array.isArray(normalizedData)
        ? normalizedData
        : []
      state.awaitingInStoreGoodsTotalElements =
        payload?.totalElements ?? state.awaitingInStoreGoods.length
      state.awaitingInStoreGoodsTotalPages =
        payload?.totalPages ?? (state.awaitingInStoreGoods.length ? 1 : 0)
    },
    [fetchAwaitingInStoreGoods.rejected]: (state, { payload, error }) => {
      state.awaitingInStoreGoodsLoading = false
      state.awaitingInStoreGoodsError = payload || error
    },
    [fetchAwaitingInStoreExtendedGoods.pending]: (state) => {
      state.awaitingInStoreGoodsLoading = true
      state.awaitingInStoreGoodsError = undefined
    },
    [fetchAwaitingInStoreExtendedGoods.fulfilled]: (state, { payload }) => {
      state.awaitingInStoreGoodsLoading = false
      const normalizedData = payload?.data || payload?.content || payload || []
      state.awaitingInStoreGoods = Array.isArray(normalizedData)
        ? normalizedData
        : []
      state.awaitingInStoreGoodsTotalElements =
        payload?.totalElements ?? state.awaitingInStoreGoods.length
      state.awaitingInStoreGoodsTotalPages =
        payload?.totalPages ?? (state.awaitingInStoreGoods.length ? 1 : 0)
    },
    [fetchAwaitingInStoreExtendedGoods.rejected]: (
      state,
      { payload, error }
    ) => {
      state.awaitingInStoreGoodsLoading = false
      state.awaitingInStoreGoodsError = payload || error
    },
    [fetchAwaitingInStoreGoodById.pending]: (state) => {
      state.awaitingInStoreGoodLoading = true
      state.awaitingInStoreGoodError = undefined
    },
    [fetchAwaitingInStoreGoodById.fulfilled]: (state, { payload }) => {
      state.awaitingInStoreGoodLoading = false
      state.awaitingInStoreGood = payload || {}
    },
    [fetchAwaitingInStoreGoodById.rejected]: (state, { payload, error }) => {
      state.awaitingInStoreGoodLoading = false
      state.awaitingInStoreGoodError = payload || error
    },
    [fetchAwaitingInStoreById.pending]: (state) => {
      state.awaitingInStoreGoodLoading = true
      state.awaitingInStoreGoodError = undefined
    },
    [fetchAwaitingInStoreById.fulfilled]: (state, { payload }) => {
      state.awaitingInStoreGoodLoading = false
      state.awaitingInStoreGood = payload || {}
    },
    [fetchAwaitingInStoreById.rejected]: (state, { payload, error }) => {
      state.awaitingInStoreGoodLoading = false
      state.awaitingInStoreGoodError = payload || error
    },
    [disposeAwaitingInStoreGood.pending]: (state) => {
      state.disposeAwaitingInStoreLoading = true
      state.disposeAwaitingInStoreError = undefined
    },
    [disposeAwaitingInStoreGood.fulfilled]: (state, action) => {
      state.disposeAwaitingInStoreLoading = false
      const disposedGoodsId = action?.meta?.arg?.goodsId

      if (disposedGoodsId) {
        state.awaitingInStoreGoods = state.awaitingInStoreGoods.filter(
          (item) => item?.id !== disposedGoodsId
        )
        state.awaitingInStoreGoodsTotalElements = Math.max(
          0,
          state.awaitingInStoreGoodsTotalElements - 1
        )

        if (state.awaitingInStoreGood?.id === disposedGoodsId) {
          state.awaitingInStoreGood = {}
        }
      }
    },
    [disposeAwaitingInStoreGood.rejected]: (state, { payload, error }) => {
      state.disposeAwaitingInStoreLoading = false
      state.disposeAwaitingInStoreError = payload || error
    },
    [fetchCargoDetails.pending]: (state) => {
      state.cargoDataLoading = true
    },
    [fetchCargoDetails.fulfilled]: (state, { payload }) => {
      state.cargoDataLoading = false
      state.cargoDetails = payload
    },
    [fetchCargoDetails.rejected]: (state, { error }) => {
      state.cargoDataLoading = false
      state.cargoDataError = error
      state.cargoDetails = null
    },
    [createWaifRegister.pending]: (state) => {
      state.waifLoading = true
    },
    [createWaifRegister.fulfilled]: (state, { payload }) => {
      state.waifDetails = payload
      state.waifLoading = false
    },
    [createWaifRegister.rejected]: (state, { error }) => {
      state.waifLoading = false
      state.waifError = error
    },
    [cancelGoods.pending]: (state) => {
      state.cancelGoodsLoading = true
    },
    [cancelGoods.fulfilled]: (state) => {
      state.cancelGoodsLoading = false
    },
    [cancelGoods.rejected]: (state, { error }) => {
      state.cancelGoodsLoading = false
      state.cancelGoodsError = error
    },
    [fetchGoodById.pending]: (state) => {
      state.isFetchGoodLoading = true
    },
    [fetchGoodById.fulfilled]: (state, action) => {
      state.isFetchGoodLoading = false
      state.fetchedGood = action.payload || {}
    },
    [fetchGoodById.rejected]: (state, action) => {
      state.isFetchGoodLoading = false
      state.fetchGoodError = action.payload
    },
    [fetchGoods.pending]: (state) => {
      state.isFetchGoodLoading = true
    },
    [fetchGoods.fulfilled]: (state, action) => {
      state.isFetchGoodLoading = false
      state.fetchedGood = action.payload || {}
      state.waifDetails = action.payload || {}
    },
    [fetchGoods.rejected]: (state, action) => {
      state.isFetchGoodLoading = false
      state.fetchGoodError = action.payload
    },
    [updateGoodThunk.pending]: (state) => {
      state.isUpdateGoodLoading = true
    },
    [updateGoodThunk.fulfilled]: (state, action) => {
      state.isUpdateGoodLoading = false
      state.fetchedGood = action.payload?.data?.responseBody?.goods || {}
    },
    [updateGoodThunk.rejected]: (state, action) => {
      state.isUpdateGoodLoading = false
      state.updateGoodError = action.payload
    },
    [fetchProductDescription.pending]: (state) => {
      state.productDescriptionLoading = true
      state.productDescriptionError = null
    },
    [fetchProductDescription.fulfilled]: (state, { payload }) => {
      state.productDescriptionLoading = false
      const product = payload?.result?.product

      if (product?.id && state.goodsParcel?.goods?.length) {
        state.goodsParcel.goods = state.goodsParcel.goods.map((good) => {
          if (good.id === product?.id) {
            return { ...good, ...product }
          }
          return good
        })
      }
    },
    [fetchProductDescription.rejected]: (state, { error, payload }) => {
      state.productDescriptionLoading = false
      state.productDescriptionError = payload || error
    },
    [fetchGoodParcelByID.pending]: (state) => {
      state.goodParcelLoading = true
    },
    [fetchGoodParcelByID.fulfilled]: (state, { payload }) => {
      state.goodParcelLoading = false
      state.goodParcelData = payload || {}
    },
    [fetchGoodParcelByID.rejected]: (state, action) => {
      state.goodParcelLoading = false
      state.goodParcelError = action.payload
    },

    [fetchGoodStatusHistory.pending]: (state) => {
      state.isFetchGoodStatusHistoryLoading = true
    },
    [fetchGoodStatusHistory.fulfilled]: (state, action) => {
      state.isFetchGoodStatusHistoryLoading = false
      state.goodStatusHistoryData = action.payload || []
    },
    [fetchGoodStatusHistory.rejected]: (state, action) => {
      state.isFetchGoodStatusHistoryLoading = false
      state.fetchGoodStatusHistoryError = action.payload
    },

    [fetchGoodCellHistory.pending]: (state) => {
      state.isFetchGoodCellHistoryLoading = true
    },
    [fetchGoodCellHistory.fulfilled]: (state, action) => {
      state.isFetchGoodCellHistoryLoading = false
      state.goodCellHistoryData = action.payload || []
    },
    [fetchGoodCellHistory.rejected]: (state, action) => {
      state.isFetchGoodCellHistoryLoading = false
      state.fetchGoodCellHistoryDataError = action.payload
    },

    [fetchDeliveryTransaction.pending]: (state) => {
      state.transactionLoading = true
    },
    [fetchDeliveryTransaction.fulfilled]: (state) => {
      state.transactionLoading = false
      state.transactionDetails = { success: true }
    },
    [fetchDeliveryTransaction.rejected]: (state, { error }) => {
      state.transactionLoading = false
      state.transactionError = error
    },
    [fetchChangeWeight.pending]: (state) => {
      state.changedGoodLoading = true
    },
    [fetchChangeWeight.fulfilled]: (state, { payload }) => {
      state.changedGoodLoading = false
      state.changedGoodData = payload || {}
    },
    [fetchChangeWeight.rejected]: (state, { error }) => {
      state.changedGoodError = error
    },
    // [fetchCargoPhotoData.pending]: (state) => {
    //   state.cargoPhotoLoading = true
    // },
    // [fetchCargoPhotoData.fulfilled]: (state, { payload }) => {
    //   state.cargoPhotoLoading = false
    //   state.cargoPhotoData = payload || []
    // },
    // [fetchCargoPhotoData.rejected]: (state, { error }) => {
    //   state.cargoPhotoLoading = false
    //   state.cargoPhotoError = error
    // },
  },
})

export const {
  deletePhotoReportPicture,
  deletePhotoDefectPicture,
  // setPhotoReportUrl,
  // setPhotoDefectUrl,
  clearPhotoReportData,
  getAdditionalServicesOfAcceptCargo,
  getOneParcelsGoods,
  clearChangedGoodData,
  filterGoodsById,
  setShouldTakePicture,
  setWebCameraData,
  setFetchedGood,
  clearWebCameraData,
  clearWaifDetailsData,
  clearPhotoDefectData,
  setCargoPhotoData,
  filterDataByDate,
  filterByParcelId,
  clearGoodsForRegistry,
  setSelectedGood,
  setGoods,
  cleanGoods,
  cleanAwaitingInStoreGoods,
  clearAwaitingInStoreGood,
  clearCargoDetails,
} = slice.actions

export const reducer = slice.reducer
export const selectorGoods = (state) => state[slice.name]

export default slice
